module.exports = __webpack_public_path__ + "img/logo-mediana.b6f52968.svg";